export default __webpack_public_path__ + "static/media/code.371706c9.jpg";